import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { isWebsocket1w1xog9vfgwm1 as isWebsocket } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { WebSocketContentagsn4p79ffe0 as WebSocketContent } from './WebSocketContent.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../../statement/HttpResponse.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance2192nrpo98q6y as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DelegatingClientWebSocketSessiono1sywc6weckz as DelegatingClientWebSocketSession,
  DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession,
} from './ClientSessions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance2qxbzj50paf3c as Phases_getInstance,
} from '../../statement/HttpResponsePipeline.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { parseWebSocketExtensionszyo25w86ylog as parseWebSocketExtensions } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketExtensionHeader.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { header3kx6g3yb4df1r as header } from '../../request/utils.mjs';
import {
  WebSocketExtensionsConfig3sf1f7u7xi63m as WebSocketExtensionsConfig,
  WebSocketExtensionixqq2y77p4e0 as WebSocketExtension,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketExtension.mjs';
import {
  WebSocketChannelsConfig1qogztyrywmj9 as WebSocketChannelsConfig,
  Companion_getInstance27kujspvp4jub as Companion_getInstance_0,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketChannelsConfig.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance_0 } from '../../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession,
  DefaultWebSocketSessionmehckluw85jl as DefaultWebSocketSession_0,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../../engine/HttpClientEngineCapability.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_REQUEST_EXTENSIONS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return REQUEST_EXTENSIONS_KEY;
}
var REQUEST_EXTENSIONS_KEY;
function get_WEBSOCKETS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return WEBSOCKETS_KEY;
}
var WEBSOCKETS_KEY;
function get_LOGGER() {
  _init_properties_WebSockets_kt__jaqpbo();
  return LOGGER;
}
var LOGGER;
function WebSockets$Plugin$install$slambda($extensionsSupported, $plugin) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var tmp;
    if (!isWebsocket($this$intercept.x4s_1.z5h_1.n55())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping WebSocket plugin for non-websocket request: ' + $this$intercept.x4s_1.z5h_1.toString();
        this_0.b4u(tmp$ret$1);
      }
      return Unit_instance;
    }
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$3 = 'Sending WebSocket request ' + $this$intercept.x4s_1.z5h_1.toString();
      this_1.b4u(tmp$ret$3);
    }
    $this$intercept.x4s_1.j5s(WebSocketCapability_instance, Unit_instance);
    var tmp_0;
    if ($extensionsSupported) {
      installExtensions($plugin, $this$intercept.x4s_1);
      tmp_0 = Unit_instance;
    }
    $this$intercept.x4s_1.e5i_1.n4n(get_WEBSOCKETS_KEY(), $plugin);
    yield* $this$intercept.z4r(new (WebSocketContent())(), $completion);
    return Unit_instance;
  }, 2);
}
function WebSockets$Plugin$install$slambda_0($plugin, $extensionsSupported) {
  return constructCallableReference(function *($this$intercept, _destruct__k2r9zo, $completion) {
    var info = _destruct__k2r9zo.ze();
    var session = _destruct__k2r9zo.af();
    var response = $this$intercept.x4s_1.s5g();
    var status = response.g5j();
    var requestContent = get_request(response).z2n();
    if (!(requestContent instanceof WebSocketContent())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping non-websocket response from ' + $this$intercept.x4s_1.q5i().z5i().toString() + ': ' + toString(requestContent);
        this_0.b4u(tmp$ret$1);
      }
      return Unit_instance;
    }
    if (!status.equals(Companion_getInstance().t52_1)) {
      throw WebSocketException().t5t('Handshake exception, expected status code ' + Companion_getInstance().t52_1.v54_1 + ' but was ' + status.v54_1);
    }
    if (!isInterface(session, WebSocketSession())) {
      throw WebSocketException().t5t('Handshake exception, expected `WebSocketSession` content but was ' + toString(getKClassFromExpression(session)));
    }
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$3 = 'Receive websocket session from ' + $this$intercept.x4s_1.q5i().z5i().toString() + ': ' + toString(session);
      this_1.b4u(tmp$ret$3);
    }
    if (!($plugin.v5t_1 === 2147483647n)) {
      session.o5b($plugin.v5t_1);
    }
    var tmp;
    if (info.p4t_1.equals(getKClass(DefaultClientWebSocketSession()))) {
      var defaultSession = $plugin.z5t(session);
      var clientSession = new (DefaultClientWebSocketSession())($this$intercept.x4s_1, defaultSession);
      var tmp_0;
      if ($extensionsSupported) {
        tmp_0 = completeNegotiation($plugin, $this$intercept.x4s_1);
      } else {
        tmp_0 = emptyList();
      }
      var negotiated = tmp_0;
      // Inline function 'kotlin.apply' call
      clientSession.n5b(negotiated);
      tmp = clientSession;
    } else {
      tmp = new (DelegatingClientWebSocketSession())($this$intercept.x4s_1, session);
    }
    var clientSession_0 = tmp;
    yield* $this$intercept.z4r(new (HttpResponseContainer())(info, clientSession_0), $completion);
    return Unit_instance;
  }, 2);
}
function installExtensions($this, context) {
  var installed = $this.w5t_1.i37();
  context.e5i_1.m4n(get_REQUEST_EXTENSIONS_KEY(), installed);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = installed.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var list = element.h5e();
    addAll(destination, list);
  }
  var protocols = destination;
  addNegotiatedProtocols($this, context, protocols);
}
function completeNegotiation($this, call) {
  var tmp0_safe_receiver = call.s5g().x51().c2o('Sec-WebSocket-Extensions');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = parseWebSocketExtensions(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var clientExtensions = call.r5i().j4n(get_REQUEST_EXTENSIONS_KEY());
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = clientExtensions.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.i5e(serverExtensions)) {
      destination.i2(element);
    }
  }
  return destination;
}
function addNegotiatedProtocols($this, context, protocols) {
  if (protocols.n1())
    return Unit_instance;
  var headerValue = joinToString(protocols, ',');
  header(context, 'Sec-WebSocket-Extensions', headerValue);
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.a5u_1 = new (WebSocketExtensionsConfig())();
        this.b5u_1 = new (WebSocketChannelsConfig())();
        this.c5u_1 = 0n;
        this.d5u_1 = 2147483647n;
        this.e5u_1 = null;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'Websocket';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(WebSockets());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(WebSockets()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.f5u_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.f5u_1;
      }
      g5u(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (WebSockets())(config.c5u_1, config.d5u_1, config.a5u_1, config.e5u_1, config.b5u_1);
      }
      g5i(block) {
        return this.g5u(block);
      }
      h5u(plugin, scope) {
        var extensionsSupported = scope.z5f_1.q5l().t2(WebSocketExtensionsCapability_instance);
        var tmp = Phases_getInstance_0().k5m_1;
        scope.f5g_1.b4t(tmp, WebSockets$Plugin$install$slambda(extensionsSupported, plugin));
        var tmp_0 = Phases_getInstance().p5h_1;
        scope.g5g_1.b4t(tmp_0, WebSockets$Plugin$install$slambda_0(plugin, extensionsSupported));
      }
      h5i(plugin, scope) {
        return this.h5u(plugin instanceof WebSockets() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var WebSocketsClass;
function WebSockets() {
  if (WebSocketsClass === VOID) {
    class $ {
      constructor(pingIntervalMillis, maxFrameSize, extensionsConfig, contentConverter, channelsConfig) {
        Plugin_getInstance();
        contentConverter = contentConverter === VOID ? null : contentConverter;
        channelsConfig = channelsConfig === VOID ? Companion_getInstance_0().t5b_1 : channelsConfig;
        this.u5t_1 = pingIntervalMillis;
        this.v5t_1 = maxFrameSize;
        this.w5t_1 = extensionsConfig;
        this.x5t_1 = contentConverter;
        this.y5t_1 = channelsConfig;
      }
      z5t(session) {
        if (isInterface(session, DefaultWebSocketSession()))
          return session;
        // Inline function 'kotlin.Long.times' call
        var this_0 = this.u5t_1;
        var timeoutMillis = multiply(this_0, fromInt(2));
        // Inline function 'kotlin.also' call
        var this_1 = DefaultWebSocketSession_0(session, this.u5t_1, timeoutMillis, this.y5t_1);
        this_1.o5b(this.v5t_1);
        return this_1;
      }
    }
    initMetadataForClass($, 'WebSockets');
    WebSocketsClass = $;
  }
  return WebSocketsClass;
}
var WebSocketExtensionsCapabilityClass;
function WebSocketExtensionsCapability() {
  if (WebSocketExtensionsCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'WebSocketExtensionsCapability';
      }
      hashCode() {
        return 806573237;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebSocketExtensionsCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WebSocketExtensionsCapability', VOID, VOID, [HttpClientEngineCapability()]);
    WebSocketExtensionsCapabilityClass = $;
  }
  return WebSocketExtensionsCapabilityClass;
}
var WebSocketExtensionsCapability_instance;
function WebSocketExtensionsCapability_getInstance() {
  return WebSocketExtensionsCapability_instance;
}
var WebSocketCapabilityClass;
function WebSocketCapability() {
  if (WebSocketCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'WebSocketCapability';
      }
      hashCode() {
        return -1146563391;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebSocketCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WebSocketCapability', VOID, VOID, [HttpClientEngineCapability()]);
    WebSocketCapabilityClass = $;
  }
  return WebSocketCapabilityClass;
}
var WebSocketCapability_instance;
function WebSocketCapability_getInstance() {
  return WebSocketCapability_instance;
}
var WebSocketExceptionClass;
function WebSocketException() {
  if (WebSocketExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(message, cause) {
        return new.target.i5u(message, cause);
      }
      static i5u(message, cause) {
        var $this = this.q(message, cause);
        captureStack($this, $this.s5t_1);
        return $this;
      }
      static t5t(message) {
        return this.i5u(message, null);
      }
    }
    initMetadataForClass($, 'WebSocketException');
    WebSocketExceptionClass = $;
  }
  return WebSocketExceptionClass;
}
var properties_initialized_WebSockets_kt_2t2hw2;
function _init_properties_WebSockets_kt__jaqpbo() {
  if (!properties_initialized_WebSockets_kt_2t2hw2) {
    properties_initialized_WebSockets_kt_2t2hw2 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'Websocket extensions';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtList());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(WebSocketExtension()), arrayOf([getStarKTypeProjection()]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    REQUEST_EXTENSIONS_KEY = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'Websocket plugin config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(WebSockets());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(WebSockets()), arrayOf([]), false);
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_4 = null;
      } else {
        throw $p_0;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_2, tmp$ret$2_0);
    WEBSOCKETS_KEY = new (AttributeKey())(name_0, tmp$ret$1_0);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
  }
}
//region block: init
WebSocketExtensionsCapability_instance = new (WebSocketExtensionsCapability())();
WebSocketCapability_instance = new (WebSocketCapability())();
//endregion
//region block: exports
export {
  WebSocketCapability_instance as WebSocketCapability_instancerfowbrsc2s1e,
  Plugin_getInstance as Plugin_getInstance2t18sf8ddmzc5,
  get_WEBSOCKETS_KEY as get_WEBSOCKETS_KEY4y3dps3lzl71,
  WebSocketException as WebSocketExceptionb5mwyitzck0i,
};
//endregion

//# sourceMappingURL=WebSockets.mjs.map
